import { render, staticRenderFns } from "./KT-ResumePositions.vue?vue&type=template&id=18fa821a&scoped=true&lang=pug&"
import script from "./KT-ResumePositions.vue?vue&type=script&lang=js&"
export * from "./KT-ResumePositions.vue?vue&type=script&lang=js&"
import style0 from "./KT-ResumePositions.vue?vue&type=style&index=0&id=18fa821a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fa821a",
  null
  
)

/* custom blocks */
import block0 from "./KT-ResumePositions.vue?vue&type=custom&index=0&blockType=html&lang=en"
if (typeof block0 === 'function') block0(component)

export default component.exports